angular.module('surfsightApp.controllers').controller('geofenceCtrl', [
  '$scope',
  '$timeout',
  '$interval',
  '$http',
  '$localStorage',
  '$mdToast',
  'edgeFactoryV2',
  '$mdSidenav',
  'nominatimLookUp',
  'geofenceFactory',
  '$stateParams',
  '$mdDialog',
  '$filter',
  '$state',
  '$rootScope',
  function editEdgeController (
    $scope,
    $timeout,
    $interval,
    $http,
    $localStorage,
    $mdToast,
    edgeFactoryV2,
    $mdSidenav,
    nominatimLookUp,
    geofenceFactory,
    $stateParams,
    $mdDialog,
    $filter,
    $state,
    $rootScope
  ) {
    var $translate = $filter('translate')
    var edgeImei = $stateParams.edge_id
    $scope.old_device = false
    $scope.proxyStatus = true

    geofenceFactory.list = []
    $scope.$emit('loadGeofencePaths', {
      geofence: {},
      edge: {}
    })
    $scope.fences_ids = []
    var $translate = $filter('translate')
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
    $scope.geofenceLoadingStatus = true
    $scope.back_sideNav = function () {
      $state.go('home.common.maps.view')
    }
    $scope.geofenceErrormsg = ''
    $scope.loadGeofenceData = () => {
      geofenceFactory.getGeofences($scope.serialNumber).then(
        function (result) {
          $scope.geofenceLoadingStatus = false
          result.data.data.forEach(function (geofence) {
            geofenceFactory.addOrUpdateItem(geofence)
            $scope.$emit('loadGeofencePaths', {
              geofence: geofence,
              edge: $scope.edge
            })
          })

          $scope.geofenceLoadingStatus = false
        },
        error => {
          $scope.geofenceLoadingStatus = false
        }
      )
    }

    if ($scope.edge) {
      $scope.edge = edgeFactoryV2.findItemByImei(edgeImei).item
      $scope.serialNumber = $scope.edge.imei
      $scope.loadGeofenceData()
    } else {
      trackItem_Edge(edgeImei)
    }

    $scope.deleteGeofence = function (ev, geofence) {
      if ($localStorage.userDetails.permission_role != 'user') {
        var geofenceID = geofence.id
        var confirm = $mdDialog
          .confirm()
          .title($translate('areYouSureYouWantToDeteleThisFence'))
          .textContent('')
          .ariaLabel($translate('deleteEdge'))
          .targetEvent(ev)
          .ok($translate('delete'))
          .cancel($translate('cancel'))
        $mdDialog.show(confirm).then(() => {
          $scope.deleteGeoFence_Device(geofenceID, geofence)
        })
      } else {
        $scope.showMessageToast($translate('accessDenied'))
      }
    }

    $scope.deleteGeoFence_Device = function (geofenceID, geofence) {
      geofenceFactory
        .deleteGeofence($scope.serialNumber, geofence.id)
        .then(function (result) {
          geofenceFactory.deleteItemById(geofenceID)
          $scope.showMessageToast($translate('fenceDeletedSuccessfully'))
          $scope.$emit('loadGeofencePaths', {
            geofence: geofence,
            edge: $scope.edge
          })
        })
    }

    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .action($translate('ok'))
        .position('top right')
        .actionKey('F1')
        .hideDelay(5000)

      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
          }
        })
        .catch(() => {})
    }
    $scope.$on('loadGeofenceDataCall', function (e, data) {
      $scope.geofenceLoadingStatus = true
      $scope.loadGeofenceData()
    })
    $scope.showGeofenceDetails = function (ev, geofence) {
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              geofence: geofence
            }
          },
          controller: 'geofenceDetailsCtrl',
          templateUrl:
            './templates/edge.geofence.details.view.html?t=' +
            window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          function (response) {},
          function () {
            //
          }
        )
    }
    function handleServerError (response) {
      $scope.$emit('handleServerError', response)
    }

    function trackItem_Edge (edgeImei) {
      edgeFactoryV2
        .getSingleDevice($rootScope.currentUserOrganization.id, edgeImei)
        .then(
          function (device) {
            $scope.edge = device
            edgeFactoryV2.addOrUpdateItem($scope.edge)
            $scope.serialNumber = $scope.edge.imei
            $scope.loadGeofenceData()
          },
          function (errorResponse) {
            handleServerError(errorResponse)
            if (errorResponse.data.status) {
              $scope.showMessageToast(errorResponse.data.status.error)
            }
          }
        )
    }
  }
])
